import { Component } from "react";
import { AppLocal } from "./AppLocal";
import { AppProduction } from "./AppProduction";

class App extends Component {
  render() {
    if (import.meta.env.DEV === true) {
      return <AppLocal />;
    } else {
      return <AppProduction />;
    }
  }
}

export default App;
